import React, {
  ReactChild,
  useContext,
  useEffect,
  useState,
  ReactNode
} from 'react';
import { createPortal } from 'react-dom';
import intl from 'react-intl-universal';
import classNames from 'classnames';
import ReactSVG from 'react-svg';
import { getPendantColor } from '../../utils/color';
import { uuid, formatCommentNumber } from '../../utils/util';
import { ThemeContext } from '../../store/ThemeProvider';
import RootStore from '../../store/RootStore';
import AllForFaceDetectionDialog from '../FaceDetection/AllForFaceDetectionDialog';
import Mask from '../Mask';
import stat from '../../utils/stat';

export interface INormalPendant {
  src?: string;
  onClick?: () => void;
  style?: React.CSSProperties;
  text?: string;
  svg?: ReactNode;
  className?: string;
  rootStore?: RootStore;
}

export const NormalPendant = (props: INormalPendant) => {
  const { backgroundColor, mainColor } = useContext(ThemeContext);
  const [pendantBgColor, pendantIconColor] = getPendantColor(mainColor, true);
  return (
    <div className={`pendant-row ${props.className || ''}`}>
      <div
        className="pendent-normal"
        onClick={props.onClick}
        style={{
          color: pendantIconColor,
          backgroundColor: pendantBgColor,
          ...props.style
        }}
      >
        {props.text ? (
          <span>{props.text}</span>
        ) : props.svg ? (
          props.svg
        ) : (
          <img src={props.src} alt="" />
        )}
      </div>
    </div>
  );
};

export interface IRefreshPendant {
  notification: number;
  onClick?: () => void;
  src?: string;
}
export const RefreshPendant = (props: IRefreshPendant) => {
  const [hideTip, setHideTip] = useState(true);
  useEffect(() => {
    if (props.notification * 1 > 0) {
      setHideTip(false);
    }
    const timer = setTimeout(() => setHideTip(true), 5000);
    return () => clearTimeout(timer);
  }, [props.notification]);
  const { notification } = props;

  const [iconActive, setIconActive] = useState(false);
  const iconClick = function() {
    setTimeout(() => {
      setIconActive(false);
    }, 1000);
    setIconActive(true);
    return props.onClick && props.onClick();
  };

  const iconCls = classNames('icon-refresh', { active: iconActive });
  const { componentColor, backgroundColor, mainColor } = useContext(
    ThemeContext
  );
  const [pendantBgColor, pendantIconColor] = getPendantColor(mainColor, true);
  return (
    <div className="pendant-row">
      <span
        className="pendant-refresh pendent-normal"
        style={{
          color: pendantIconColor,
          backgroundColor: pendantBgColor
        }}
      >
        {/*notification * 1 > 0 ? (
          <span
            className={classNames(
              'pendant-notification',
              hideTip ? 'hide' : ''
            )}
          >
            {intl.get('photo update', { num: Math.min(notification, 99) })}
          </span>
        ) : null*/}
        <span className={iconCls} onClick={iconClick} />
      </span>

      {notification * 1 > 0 ? (
        <div className="pendant-badge">{Math.min(notification, 99)}</div>
      ) : null}
    </div>
  );
};

interface ISettingPendantTypeList {
  type: string;
  name: string;
}

export interface ISettingPendant {
  typeList: ISettingPendantTypeList[];
  order: string; // 正序倒序
  typeClick: (type: string) => void;
  orderClick: () => void;
  // lanClick: () => void;
}
// 不期望wrapper rootStore
export const SettingPendant = (props: ISettingPendant) => {
  // const isChinese = intl.getInitOptions().currentLocale === 'zh-CN';
  const [showLeft, setShowLeft] = useState(false);
  const typeClick = (type: string) => {
    props.typeClick(type);
    setShowLeft(false);
  };
  const orderClick = () => {
    props.orderClick();
    setShowLeft(false);
  };
  // const lanClick = () => {
  //   props.lanClick();
  //   setShowLeft(false);
  // };

  useEffect(() => {
    // 产品希望第一次打开的时候能够自动打开一下: 每个用户只提示这1次，再次进入其他子相册或其他相册，均不提示
    if (!localStorage['hideShowSetting']) {
      localStorage['hideShowSetting'] = 1;
      setShowLeft(true);
      const timer = window.setTimeout(() => {
        setShowLeft(false);
      }, 1000);
      return () => {
        clearTimeout(timer);
      };
    }
  }, []);

  useEffect(() => {
    if (showLeft) {
      window.dispatchEvent(new Event('hide-video'));
    }
  }, [showLeft]);

  const { componentColor, backgroundColor, mainColor } = useContext(
    ThemeContext
  );
  const [pendantBgColor, pendantIconColor] = getPendantColor(mainColor, true);
  return (
    <div className="pendant-row">
      {!!showLeft
        ? createPortal(
            <Mask onClick={() => setShowLeft(false)} />,
            document.body
          )
        : null}
      <div className={classNames('setting-left-wrapper', { hide: !showLeft })}>
        <div
          className={classNames('setting-left')}
          style={{
            color: pendantIconColor,
            backgroundColor: pendantBgColor
          }}
        >
          <div className="gallery-type-group">
            {props.typeList.map(one => (
              <div
                className="one-item"
                key={one.type}
                onClick={typeClick.bind(null, one.type)}
              >
                {one.name}
              </div>
            ))}
          </div>
          <div
            className="vertical-line"
            style={{ backgroundColor: pendantIconColor }}
          />
          <div className="one-item" onClick={orderClick}>
            {props.order === 'asc' ? intl.get('DESC') : intl.get('ASC')}
          </div>
          {/*<div*/}
          {/*  className="vertical-line"*/}
          {/*  style={{ backgroundColor: pendantIconColor }}*/}
          {/*/>*/}
          {/*<div className="one-item" onClick={lanClick}>*/}
          {/*  {isChinese ? 'EN' : '中文'}*/}
          {/*</div>*/}
        </div>
        <div
          className="triangle"
          style={{ borderLeftColor: pendantIconColor }}
        />
      </div>
      <div
        className="pendent-row"
        onClick={() => {
          setShowLeft(prevState => !prevState);
        }}
      >
        <div
          className="pendent-normal"
          style={{
            fill: pendantIconColor,
            backgroundColor: pendantBgColor
          }}
        >
          <ReactSVG
            src={require('../../svg/icon-setting.svg')}
            style={{ width: 18, height: 18 }}
          />
        </div>
      </div>
    </div>
  );
};

export const FindPendant = (props: INormalPendant) => {
  const { componentColor, backgroundColor, mainColor } = useContext(
    ThemeContext
  );
  const [pendantBgColor, pendantIconColor] = getPendantColor(mainColor, true);

  const [showDialog, setShowDialog] = useState(false);

  return (
    <div className={`pendant-row pendant-find`}>
      <span
        className="pendant-refresh pendent-normal"
        style={{
          color: pendantIconColor,
          backgroundColor: pendantBgColor
        }}
        onClick={() => setShowDialog(true)}
      >
        <span style={{ fontSize: 12 }}>{intl.get('Find')}</span>
      </span>

      {showDialog ? (
        <AllForFaceDetectionDialog
          hide={() => setShowDialog(false)}
          success={() => {
            window.dispatchEvent(new Event('show-find-people-result'));
          }}
          personStatus={undefined}
          find={true}
        />
      ) : null}
    </div>
  );
};

const GOOD_ICONS = {
  border: require('../../assets/good/good-border.png'),
  icons: [
    require('../../assets/good/good-1.png'),
    require('../../assets/good/good-2.png'),
    require('../../assets/good/good-3.png'),
    require('../../assets/good/good-4.png'),
    require('../../assets/good/good-5.png'),
    require('../../assets/good/good-6.png')
  ]
};

let GOOD_BOOST_TIMER = 0;
let GOOD_POINT_TIMER = 0;

export const GoodPendant = (props: INormalPendant) => {
  const { src } = props;
  const { backgroundColor, mainColor } = useContext(ThemeContext);
  const [pendantBgColor, pendantIconColor] = getPendantColor(mainColor, true);

  const [borderId, setBorderId] = useState('');
  const [count, setCount] = useState(0);

  useEffect(() => {
    setBorderId(uuid());

    // 统计这块，肯定是异步的，有时候刷新界面后，看到的还是老数据，所以把自己看到的数据存到本地，取与服务器数据相比中的最大值
    let defaultData = window.gallery.praise || 0;
    let localData = window.localStorage.getItem(`${window.gallery.id}_praise`);

    defaultData = Math.max(Number(localData), defaultData);
    setCount(defaultData);
  }, []);

  const resetBorder = () => {
    clearTimeout(GOOD_BOOST_TIMER);

    setCount(count + 1);
    window.localStorage.setItem(
      `${window.gallery.id}_praise`,
      String(count + 1)
    );
    stat.count('praise_trigger');

    let borderDom = document.getElementById(`border_${borderId}`);
    let pointDom = document.getElementById(`point_${borderId}`);

    if (borderDom) {
      borderDom.className = `border boost`;
      borderDom.style.transform = `rotate(${Math.round(Date.now() / 1000) %
        360}deg)`;

      // @ts-ignore
      GOOD_BOOST_TIMER = setTimeout(() => {
        borderDom && (borderDom.className = 'border');
      }, 300);
    }

    clearTimeout(GOOD_POINT_TIMER);

    if (pointDom) {
      let iconRandom = Math.floor(Math.random() * 6);
      let animationRandom = Math.ceil(Math.random() * 5);

      let img = document.createElement('img');
      img.src = GOOD_ICONS.icons[iconRandom];
      img.className = `ball${animationRandom}`;

      pointDom.appendChild(img);

      // @ts-ignore
      GOOD_POINT_TIMER = setTimeout(() => {
        // 清除掉所有DOM结点
        pointDom && (pointDom.innerHTML = '');
      }, 2800);
    }
  };

  return (
    <div
      className={`pendant-row pendant-good`}
      onClick={() => {
        resetBorder();
      }}
    >
      <div id={`border_${borderId}`} className={`border`}>
        <img src={GOOD_ICONS.border} />
      </div>
      <div
        className="pendent-normal"
        style={{
          color: pendantIconColor,
          backgroundColor: pendantBgColor,
          ...props.style
        }}
      >
        <img src={props.src} alt="" />
        {count > 0 ? (
          <div className="good-number">{formatCommentNumber(count)}</div>
        ) : null}
      </div>
      <div id={`point_${borderId}`} className="points"></div>
    </div>
  );
};
